import script from "./LingoDataTableComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoDataTableComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LingoDataTableComponent.vue?vue&type=style&index=0&id=e104b31e&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e104b31e"]])

export default __exports__